module.exports = __webpack_public_path__ + "img/calendar-w.6d99053f.svg";